<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Agendamento | {{ id }}
          </p>
          <div class="heading-elements">
            <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
          </div>
        </div>

        <div class="box-body">
          <div class="form-group col-12 col-md-6">
            <label for="dt_agendada">Data Agendada: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.dt_agendada }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="status_desc">Status: &nbsp;&nbsp;&nbsp;</label>
            <span class="label" v-bind:class="{
                'label-warning': registro.idc_status === 1,
                'label-info': registro.idc_status === 2,
                'label-default': registro.idc_status === 3,
                'label-success': registro.idc_status === 4,
                'label-danger': [5,9].includes(registro.idc_status)
              }">{{ registro.status_desc }}</span>
          </div>

          <div class="form-group col-12 col-md-6" style="padding-left: 0;">
            <div class="form-group col-12 col-md-12">
              <label for="motorista.nome">Motorista: &nbsp;&nbsp;&nbsp;</label>
              <a href="#" @click="abrirMotorista(registro.cd_motorista)">{{ registro.motorista ? registro.motorista.nome : '' }}</a>
            </div>
            <div class="form-group col-12 col-md-12">
              <label for="motorista.cpf">CPF Motorista: &nbsp;&nbsp;&nbsp;</label>
              {{ registro.motorista ? registro.motorista.cpf : '' }}
            </div>
            <div class="form-group col-12 col-md-12">
              <label for="motorista.tel_celular">Telefone Motorista: &nbsp;&nbsp;&nbsp;</label>
              {{ registro.motorista ? registro.motorista.tel_celular : '' }}
            </div>
          </div>

          <div class="form-group col-12 col-md-6" style="padding-left: 0;">
            <div class="form-group col-12 col-md-12">
              <label for="ponto_apoio.cd_ponto_apoio">Ponto de Apoio: &nbsp;&nbsp;&nbsp;</label>
              {{ registro.ponto_apoio ? registro.ponto_apoio.cd_ponto_apoio : '' }}
            </div>
            <div class="form-group col-12 col-md-12">
              <label for="ponto_apoio.cnpj">CNPJ Ponto de Apoio: &nbsp;&nbsp;&nbsp;</label>
              {{ registro.ponto_apoio ? registro.ponto_apoio.cnpj : '' }}
            </div>
            <div class="form-group col-12 col-md-12">
              <label for="ponto_apoio.telefone">Telefone Ponto de Apoio: &nbsp;&nbsp;&nbsp;</label>
              {{ registro.ponto_apoio ? registro.ponto_apoio.telefone : '' }}
            </div>
          </div>

          <div class="form-group col-12 col-md-6">
            <label for="ponto_apoio.cd_ponto_apoio">Observações: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.observacao }}
          </div>
          <div class="form-group col-6 col-md-6" v-show="![null,undefined].includes(registro.motivo_nao_execucao)">
            <label for="ponto_apoio.cnpj">Motivo Não Execução: &nbsp;&nbsp;&nbsp;</label>
            {{ ![null,undefined].includes(registro.motivo_nao_execucao) ? registro.motivo_nao_execucao.descricao : '' }}
          </div>
        </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" class="btn btn-warning" @click="voltar()">Voltar</button>
            <button type="button" class="btn btn-info" @click="editar()">Editar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCnpj, formatCpf } from '@brazilian-utils/formatters'
import moment from 'moment'
import Actions from '../../actions/AgendamentoActions'
import Formatters from '../../helpers/Formatters'

export default {
  name: 'detalhes',
  props: ['id'],
  data () {
    return {
      registro: {
        cd_agendamento: '',
        cd_motorista: '',
        cd_ponto_apoio: '',
        dt_agendada: '',
        observacao: '',
        status_desc: '',
        motorista: {
          nome: '',
          cpf: '',
          tel_celular: ''
        },
        ponto_apoio: {
          descricao: '',
          cnpj: '',
          telefone: ''
        }
      }
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Detalhes'
    this.$parent.$parent.$data.showModalLoader = true

    Actions.obterAgendamento(this.id)
      .then(res => {
        if (res && res.cd_motorista) {
          this.registro = res

          this.registro.motorista.cpf = formatCpf(this.registro.motorista.cpf)
          this.registro.motorista.tel_celular = Formatters.formataNumeroTelefone(this.registro.motorista.tel_celular)

          this.registro.ponto_apoio.cnpj = formatCnpj(this.registro.ponto_apoio.cnpj)
          this.registro.ponto_apoio.telefone = Formatters.formataNumeroTelefone(this.registro.ponto_apoio.telefone)

          if (this.registro.dt_agendada !== null) {
            this.registro.dt_agendada = this.formatarData(this.registro.dt_agendada, (this.registro.ponto_apoio ? this.registro.ponto_apoio.idc_agenda_hora : false))
          }
        } else {
          this.errorMessage = 'Registro não encontrado.'
        }

        this.$parent.$parent.$data.showModalLoader = false
      })
      .catch(() => {
        this.errorMessage = 'Registro não encontrado.'

        this.$parent.$parent.$data.showModalLoader = false
      })
  },
  methods: {
    voltar () {
      this.$router.push((this.$route.query.ret_url ? this.$route.query.ret_url : '/agendamentos'))
    },
    editar () {
      this.$router.push(`/agendamentos/${this.id}/e`)
    },
    abrirMotorista (id) {
      this.$router.push(`/motoristas/${id}`)
    },
    formatarData (val, exibeHora = false) {
      const date = moment(val)

      if (date.isValid()) {
        return exibeHora ? date.format('DD/MM/YYYY HH:mm') : date.format('DD/MM/YYYY')
      }

      return ''
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/agendamentos/Detalhes.vue